import { RouterProvider } from "react-router-dom";
import { router } from "./router";

export default function MainApp() {
  return <RouterProvider router={router} />;
}